export * from "./getSingleMethodMessageKey";
